import { UploadOutlined } from '@ant-design/icons';
import type { UploadFile } from 'antd';
import { Button, Upload } from 'antd';
import { UploadChangeParam } from 'antd/es/upload';
import axios from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';


function KFAttachment({ onChangeInput, onChange, ...props }: any) {
    const { t } = useTranslation();
    const [fileList, setFileList] = useState<UploadFile[]>();
    const handleSubmit = async (e: UploadChangeParam<UploadFile<any>>) => {
        const file = e.file;
        if (file && file.originFileObj) {
            setFileList([{
                uid: '1',
                name: file.name,
                status: 'uploading',
            }]);

            const formData = new FormData();
            formData.append('file', file.originFileObj);
            formData.append('title', file.name);
            formData.append('description', file.name);

            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/upload/file`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                }).then((res) => res.data);
                if (response) {
                    const path = response?.result?.contentVersion?.fields?.VersionDataUrl?.value;
                    if (path) {
                        onChangeInput(path);
                    }
                    setFileList((file) => {
                        if (file && file[0]) {
                            return [{
                                ...file[0],
                                status: "done"
                            }]
                        }
                    });
                }
            } catch (error) {
                console.error('Error uploading file:', error);
                setFileList((file) => {
                    if (file && file[0]) {
                        return [{
                            ...file[0],
                            status: "error"
                        }]
                    }
                });
            }
            onChange(e);
        }
        return false;
    };
    return (
        <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column", rowGap: 5 }} >
            <Upload
                fileList={fileList}
                multiple={false}
                {...props}
                // beforeUpload={() => false}
                onChange={handleSubmit}
                onRemove={() => {
                    setFileList([])
                    onChangeInput("")
                    onChange();
                }}
            >
                <Button style={{ height: 44 }} icon={<UploadOutlined />}>{t("Click to Upload")}</Button>
            </Upload>
        </div>
    )
}

export default KFAttachment;